import { render, staticRenderFns } from "./terms_of_service.vue?vue&type=template&id=0bd4a2c6&scoped=true&"
var script = {}
import style0 from "./terms_of_service.vue?vue&type=style&index=0&id=0bd4a2c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd4a2c6",
  null
  
)

export default component.exports